/*
 * Get-address-location.ts
 * Description: Includes the declaration
 * of the function for geocoding
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {GMJSAK} from '@/ts/variables';

/**
 * Finish a delivery
 *
 * @return {Object} Promise - response with location
 * @param {String} address - id of the delivery
 */
export function getAddressLocation(address: string) {
    delete Axios.defaults.headers.common['X-Requested-With'];
    address = address + ', България';
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: 'https://maps.googleapis.com/maps/api/geocode/json',
            method: 'get',
            params: {
                address,
                key: GMJSAK,
            },
        }).then((response) => {
            resolve(response);
        }).catch(() => {
            reject();
        });
    });
}
